module.exports = __webpack_public_path__ + "static/media/Barcelona_1-DSC_0277.606b2867.jpg";